import { OMIT_AUTH_ROUTES_IN_PERCOLATE } from '../constants'

export const omitAuthRoutes = () => {
    if (!OMIT_AUTH_ROUTES_IN_PERCOLATE) {
        return false
    }
    return Boolean(window.isPercolate)
}
